import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { keys } from 'hooks/incident/useRoster';
import { workLogKeys } from 'hooks/incident/useWorkLog';
import type { ActivationResponse } from 'hooks/incident/useActivationActions';

interface UpdateMemberActivationParams {
  incident_id: string;
  member_user_guid: string;
  is_activated: boolean;
  decline_note?: string;
  activation_response?: ActivationResponse;
  response_comment?: string;
}

export const useUpdateMemberActivation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateMemberActivationParams) => {
      const response = await axios.post(
        apiConfig.apiGateway.updateMemberActivation,
        params
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [keys.incidentRoster, variables.incident_id],
      });

      queryClient.invalidateQueries({
        queryKey: workLogKeys.byIncident(variables.incident_id),
      });

      if (variables.activation_response === 'resend_24h') {
        toast.success('Resend requested in 24 hours');
      } else if (variables.activation_response === 'resend_48h') {
        toast.success('Resend requested in 48 hours');
      } else if (variables.is_activated) {
        toast.success('Member activation confirmed');
      } else {
        toast.success('Member activation declined');
      }
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.ERROR || 'Failed to update activation status'
      );
    },
  });
};
